var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgF1ModePresent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 11L14 29.32V59h50V29.32L38 11zm-1.76 6.76A3 3 0 0140.43 22c-.097.125-.208.24-.33.34a3 3 0 01-4.916-2.536 3 3 0 011.056-2.054v.01zM47 39.5a1.5 1.5 0 11-3 0V29a1.08 1.08 0 00-1-1h-1v27.5a1.5 1.5 0 11-3 0V43h-2v12.5a1.5 1.5 0 11-3 0V28h-1a1 1 0 00-1 1v10.5a1.5 1.5 0 11-3 0V29a4 4 0 014-4h10a4 4 0 014 4v10.5z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/F1_Mode_present.db03a948.svg";
export { SvgF1ModePresent as ReactComponent };